import React from 'react';

interface IOwnProps {
    alwaysVisible?: boolean;
    useOverflow?: boolean;
    isLarge?: boolean;
}

type Props = IOwnProps;

class Tags extends React.Component<Props, {}> {
    public render() {
        if (!this.props.children) {
            return null;
        }

        return <div className={'tags'.cAppend(this.props.alwaysVisible, 'tags--always-visible').cAppend(this.props.useOverflow, 'tags--overflow').cAppend(this.props.isLarge, 'tags--large')}>
            <ul className="tags__list">
                {this.props.children}
            </ul>
        </div>;
    }
}

export default Tags;